import { ArrowLongRightIcon } from "@heroicons/react/24/outline";
import {serviceName} from "../../../data/booking/constants/service_types";
import {Link, useNavigate} from "react-router-dom";
import {generate} from "../../../routing/routes";
import hikingImage from "../../../theme/img/bg/marcheurs2.jpeg";
import * as quotationStatus from "../../../data/booking/constants/quotation_status";
import React from "react";
import moment from 'moment'
import {isEditable} from "../../../data/followup/selectors/followup";
import {EditButton, NextButton, OrangeButton} from "../../shared/components/Buttons";
import {isEmpty} from "lodash";
import {useTranslation} from "react-i18next";
import EditButtonContainer from "../../followup/containers/EditButtonContainer";
import {Alert} from "../../shared/components/Alert";

const Status = ({ data }) => {

    if ('quotation' == data.type) {
        return <div className="italic mt-4">{quotationStatus.statusName(data.status)}</div>
    }
    if(data.payment_status == 'unpaid'){
        return <div className="italic mt-4">En attente de paiement</div>
    }
};

export default function TripBigCard({ trip }) {
    const picture = trip.mainRoute.picture ? trip.mainRoute.picture : hikingImage
    const { t } = useTranslation()
    const navigate = useNavigate()

    return (
        <div
            className="
                overflow-hidden rounded-xl border border-gray-100 shadow-lg
                lg:flex lg:flex-row-reverse mb-2
            "
        >
            <div className={"lg:w-7/12"}>
                <div
                    className={
                        "aspect-w-8 aspect-h-3 h-full w-full rounded-lg bg-cover bg-center lg:rounded-none"
                    }
                    style={{
                        backgroundImage: `url(${picture})`,
                    }}
                ></div>
            </div>
            <div className={"p-4 pt-0 lg:w-5/12 lg:px-12 lg:py-8"}>
                <div className="mt-4 items-start justify-between lg:mt-0">
                    <div className="w-full lg:mb-4">
                        <p className="text-sm font-bold text-gray-800 lg:text-xl">
                            {trip.mainRoute.title}
                        </p>
                        <p className="text-sm text-gray-600">
                            {trip.services.map((service, index) => (
                                <span key={index}>
                                    {index != 0 && " · "}
                                    {serviceName(service.type)}
                                </span>
                            ))}
                        </p>
                    </div>
                    <div>
                        <div className="flex flex-wrap items-center">
                            <span>{moment(trip.startAt).format('DD MMM')}</span>
                            {trip.startAt != trip.endAt  && <>
                                <ArrowLongRightIcon className="h-4 w-4" aria-hidden="true" />
                                <span>{moment(trip.endAt).format('DD MMM')}</span>
                            {/*<div className="text-xs text-gray-500">2023</div>*/}</>}
                        </div>
                    </div>
                    <Status data={trip} />
                    {!isEmpty(trip.pendingServices) && <Alert className="mt-5" alert="warning">{t('booking.update.quotation.information')}</Alert>}
                    <div className="flex mt-4 gap-x-4 items-center">
                        {isEmpty(trip.pendingServices) && <EditButtonContainer data={trip} />}
                        <NextButton
                            onClick={() => navigate(generate('customer_reservation', {'reference': trip.reference}))}
                            classname="!py-2"
                        >
                            Voir le détail
                        </NextButton>
                    </div>
                </div>
            </div>
        </div>
    );
}
